import { CACHED_NOTICE_LIST } from "@/core/constant";
import Storage from "@/core/services/storage";
let lockr = new Storage("cpms_");
export type Holidays = {
    holidays: Array<string>;
    workdays: Array<string>;
  };
export default {
  namespaced: true,
  state: {
    holidays: [],// 节假日
    workdays: [],// 周六周日调休日期
  },
  mutations: {
    SET_holidays: function (state, list) {
      state.holidays = list;
    },
    SET_workdays: function (state, list) {
      state.workdays = list;
    },
  },
  actions: {},
  getters: {},
};
